import { ReactNode } from "react";
import styled from "styled-components";

interface SelectProps {
  children: ReactNode;
  onChange?(value: any): void;
  value: string;
  disabled?: boolean;
}

export function Select({ children, onChange, value, disabled }: SelectProps) {
  function runOnChange(_value: any) {
    
    if(onChange) {
      onChange(_value);
    }
  }

  return (
    <Component
      value={value}
      onChange={(e) => runOnChange(e.target.value as any)}
      disabled={disabled}
    >
      {children}
    </Component>
  );
}

const Component = styled.select`
  width: 100%;
  height: 65px;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.colors.gray.light };
  border: ${({ theme }) => `2px solid ${theme.colors.gray.dark}` };
  font-size: 17px;
  padding: 0 16px;
  color: ${({ theme }) => theme.colors.gray.darker };
  
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: '';

  @media screen and (max-width: ${({ theme }) => theme.device.mobile}) {
    height: 54px;
    font-size: 15px;
    max-width: 100%;
  }
`;